/* KC PLATE - the design line's product page.
 *
 * Four jobs and no more: switch the plate from the rail, swap the size in
 * place, open the zoom, and hand the add-to-cart to the theme's existing cart
 * module. The size swap also announces itself so kc-ar.js can repoint the AR
 * anchor - see the dispatch in selectVariant.
 *
 * ⛔ STILL NO OPTION RESOLVER, and the difference matters. The axis controls are
 * plain anchors to ?variant=<id> and they still work with JS off - that ruling
 * stands. What this adds is a SWAP over the top of them, on the one axis the
 * design line has. It is not madtag's resolver: nothing is resolved, because
 * there is nothing to resolve. A tab names its variant and this repaints.
 *
 * WHY IT EXISTS. JB, 2026-09-08: "very very slow". A size click was a full
 * navigation of a page carrying 21 external scripts and 163KB of inline JS -
 * GTM, Turnstile, Judge.me, shop-js, the perf kit - all of it re-run to change a
 * price and three pictures. The document alone measured 0.3-0.7s TTFB before any
 * of that started. Everything the swap needs is already in the DOM: every size's
 * room views are rendered hidden, and the tab carries its own price.
 *
 * ⛔ DO NOT GROW THIS INTO A MULTI-AXIS RESOLVER. If a design-line product ever
 * carries two options, that is a catalogue decision to make deliberately.
 *
 * ⛔ AND THERE IS NO SECOND CART. window.KCCart is src/cart.ts, loaded globally.
 * If it is missing or throws, the native form POST runs instead - which is what
 * happens with JS off too.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-kc-plate]');
  if (!root) return;

  /* ── the rail ──────────────────────────────────────────────────────────
   * The rail holds EVERY size's room views. `data-kcp-var` says which size a
   * view belongs to; a view with no `data-kcp-var` is the work and belongs to
   * all of them. `active` is the set the buyer can actually reach, and the
   * counter counts within it - so the ordinal reads 2/4 whichever size is
   * chosen, rather than 5/7 across a rail that is mostly hidden. */
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-kcp-view]'));
  var shots = Array.prototype.slice.call(root.querySelectorAll('[data-kcp-shot]'));
  var count = root.querySelector('[data-kcp-count]');
  var form = root.querySelector('[data-kcp-form]');
  var idField = form && form.querySelector('input[name="id"]');
  var activeVar = idField ? idField.value : '';

  function mine(el) {
    var v = el.getAttribute('data-kcp-var');
    return !v || v === activeVar;
  }

  function active() { return shots.filter(mine); }

  function show(key) {
    var list = active();
    var i = 0, hit = false;
    shots.forEach(function (s) { s.hidden = true; });
    list.forEach(function (s, n) {
      if (s.getAttribute('data-kcp-shot') === key) { s.hidden = false; i = n; hit = true; }
    });
    /* A key that is not in the active set (an old size's room, after a swap)
     * falls back to the work rather than leaving the stage blank. */
    if (!hit && list.length) { list[0].hidden = false; i = 0; }
    thumbs.forEach(function (t) {
      t.setAttribute('aria-current',
        !t.hidden && t.getAttribute('data-kcp-view') === key ? 'true' : 'false');
    });
    if (count) count.textContent = String(i + 1);
  }

  function shownIndex() {
    var list = active();
    for (var i = 0; i < list.length; i++) if (!list[i].hidden) return i;
    return 0;
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      show(t.getAttribute('data-kcp-view'));
    });
  });

  /* Set the counter from the server-rendered state rather than assuming 1. */
  (function syncCount() {
    if (count) count.textContent = String(shownIndex() + 1);
  })();

  /* ── the size tabs, swapped in place ─────────────────────────────────── */
  var tabs = Array.prototype.slice.call(root.querySelectorAll('.kcp-tab[data-kcp-var]'));
  var priceNow = root.querySelector('[data-kcp-price-now]');
  var priceWas = root.querySelector('[data-kcp-price-was]');
  var cta = root.querySelector('.kcp-cta');
  var ctaLabel = cta ? cta.textContent : '';
  var wish = root.querySelector('[data-wishlist-toggle]');

  function selectVariant(vid) {
    var tab = null;
    tabs.forEach(function (t) { if (t.getAttribute('data-kcp-var') === vid) tab = t; });
    if (!tab) return false;

    /* Hold the ordinal across the swap: on room view 2 of the 30x40, land on
     * room view 2 of the 45x60. That is the comparison the room views exist to
     * make, and it is lost if the swap sends you back to the work every time. */
    var keep = shownIndex();

    activeVar = vid;
    thumbs.forEach(function (t) {
      var v = t.getAttribute('data-kcp-var');
      t.hidden = !!v && v !== vid;
    });
    tabs.forEach(function (t) {
      if (t === tab) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });

    if (idField) idField.value = vid;
    if (priceNow && tab.getAttribute('data-kcp-price')) {
      priceNow.textContent = tab.getAttribute('data-kcp-price');
    }
    if (priceWas) {
      var was = tab.getAttribute('data-kcp-was');
      if (was) { priceWas.textContent = was; priceWas.hidden = false; }
      else { priceWas.hidden = true; }
    }
    if (cta) {
      var ok = tab.getAttribute('data-kcp-available') !== 'false';
      cta.disabled = !ok;
      cta.textContent = ok ? ctaLabel : 'Sold out';
    }
    /* assets/wishlist.js reads these attributes when the button is pressed, not
     * when it binds, so keeping them current is enough - no rebind. */
    if (wish) {
      if (tab.getAttribute('data-kcp-price')) {
        wish.setAttribute('data-product-price',
          tab.getAttribute('data-kcp-price').replace(/[^0-9.]/g, ''));
      }
      wish.setAttribute('data-product-url', tab.getAttribute('href'));
    }

    var list = active();
    var next = list[Math.min(keep, list.length - 1)];
    show(next ? next.getAttribute('data-kcp-shot') : '');

    /* ── announce the swap ────────────────────────────────────────────────
     * The AR anchor lives in the plate's tool column, not in this file's
     * reach, and the size IS the object it launches - an 810 x 380 plate and a
     * 600 x 300 plate are the same artwork and different geometry. So the swap
     * is announced and kc-ar.js repoints its own href.
     *
     * ⛔ `ar` IS SENT AS null WHEN THIS SIZE HAS NO MODEL, never omitted.
     * kc-ar.js hides its anchor and drops the href on an empty `ar`; it cannot
     * act on an absence it is never told about, and the previous size's link
     * left in place is the one failure AR exists to prevent.
     *
     * The event does NOT bubble - kc-ar.js listens on this root, which is the
     * node it finds with closest('[data-kc-plate]'). Nothing else subscribes.
     *
     * ⛔ DO NOT GROW THIS INTO A GENERAL BUS. One event, one subscriber, one
     * fact. A second listener wanting a different shape of detail is a reason
     * to give it its own event, not to widen this one. */
    var glb = tab.getAttribute('data-kcp-glb');
    var usdz = tab.getAttribute('data-kcp-usdz');
    root.dispatchEvent(new CustomEvent('kcp:variant', {
      detail: {
        id: vid,
        ar: (glb && usdz) ? { glb: glb, usdz: usdz, label: tab.textContent.trim() } : null
      }
    }));

    return true;
  }

  if (tabs.length > 1 && window.history && window.history.pushState) {
    tabs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        var vid = t.getAttribute('data-kcp-var');
        if (vid === activeVar) { e.preventDefault(); return; }
        if (!selectVariant(vid)) return;      /* fall through to the anchor */
        e.preventDefault();
        window.history.pushState({ kcpVariant: vid }, '', t.getAttribute('href'));
      });
    });
    /* pushState without this would break the back button, which the plain
     * anchors got for free. */
    window.addEventListener('popstate', function () {
      var m = /[?&]variant=(\d+)/.exec(window.location.search);
      if (m) selectVariant(m[1]);
    });
  }

  /* ── the story's Read more ──────────────────────────────────────────────
   * The clamp is already painted by the server; this only opens and shuts it,
   * and hides the button when the words fit in two lines anyway. Re-measured
   * on resize, because a phone held sideways can fit what upright could not. */
  var story = root.querySelector('[data-kcp-story]');
  var storyBody = story && story.querySelector('.kcp-story-body');
  var more = story && story.querySelector('[data-kcp-readmore]');

  if (story && storyBody && more) {
    var measure = function () {
      if (story.classList.contains('is-open')) return;
      story.classList.toggle('is-short', storyBody.scrollHeight <= storyBody.clientHeight + 1);
    };
    measure();
    /* The serif is a web font; line breaks move when it lands. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    window.addEventListener('resize', measure);
    more.addEventListener('click', function () {
      var open = story.classList.toggle('is-open');
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.textContent = open ? 'Read less' : 'Read more';
    });
  }

  /* ── zoom ────────────────────────────────────────────────────────────────
   * <dialog> is supported everywhere the theme targets. If showModal is missing
   * the button simply does nothing rather than throwing into the console. */
  var dlg = document.querySelector('[data-kcp-zoomdlg]');
  var zimg = dlg && dlg.querySelector('[data-kcp-zoomimg]');
  var zbtn = root.querySelector('[data-kcp-zoom]');

  function currentImg() {
    for (var i = 0; i < shots.length; i++) {
      if (!shots[i].hidden) return shots[i].querySelector('img');
    }
    return null;
  }

  if (zbtn && dlg && zimg && typeof dlg.showModal === 'function') {
    zbtn.addEventListener('click', function () {
      var img = currentImg();
      if (!img) return;
      /* srcset gives the browser a small file for a 380px slot; the zoom wants
       * the biggest one Shopify will serve for this image. */
      zimg.removeAttribute('srcset');
      zimg.src = img.currentSrc || img.src;
      zimg.alt = img.alt || '';
      /* carry the intrinsic size across too - the markup's width/height came
       * from the hero, and a different view can be a different shape. */
      if (img.naturalWidth) {
        zimg.setAttribute('width', String(img.naturalWidth));
        zimg.setAttribute('height', String(img.naturalHeight));
      }
      dlg.showModal();
    });
    var zx = dlg.querySelector('[data-kcp-zoomclose]');
    if (zx) zx.addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) dlg.close();
    });
  } else if (zbtn) {
    zbtn.hidden = true;
  }

  /* ── add to cart ─────────────────────────────────────────────────────── */
  if (!form) return;

  form.addEventListener('submit', function (e) {
    var cart = window.KCCart;
    if (!cart || typeof cart.addToCart !== 'function') return; /* native POST */

    var idField = form.querySelector('input[name="id"]');
    var id = idField && parseInt(idField.value, 10);
    if (!id) return;

    e.preventDefault();
    var btn = form.querySelector('.kcp-cta');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }

    cart.addToCart(id, 1).then(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'Added'; }
      window.setTimeout(function () { if (btn) btn.textContent = label; }, 1600);
    }).catch(function () {
      /* The fetch path failed. Fall back to the thing that always works rather
       * than leaving the buyer with a dead button. */
      if (btn) { btn.disabled = false; btn.textContent = label; }
      form.submit();
    });
  });
})();
